import { clsx } from 'clsx'

import {
  EventRegistration,
  Maybe,
  Member,
  MemberStatus,
} from '@tribeplatform/gql-client/types'
import { MemberAvatarProps } from '@tribeplatform/react-components/common/components'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { analyticsNumberFormatter } from '../../../../Analytics/utils/parser.js'
import { dayjs } from '../../../../common/lib/dayjs.js'
import { T } from '../../../../i18n/index.js'
import { MemberAvatars } from '../MemberAvatars.js'

interface Props {
  className?: string
  visibleCount?: number
  avatarSize?: MemberAvatarProps['size']
  highlighted?: boolean
  preview?: boolean
  recentRegistrations?: Maybe<Array<EventRegistration>>
  endTime?: string
}

const STATIC_MEMBERS: Member[] = [
  {
    attributes: {
      locale: '',
    },
    createdAt: '',
    flagged: false,
    id: '1',
    locale: '',
    networkId: '',
    roleId: '',
    status: MemberStatus.VERIFIED,
    teammate: false,
    updatedAt: '',
    username: 'f',
    name: 'Farzan',
  },
  {
    attributes: {
      locale: '',
    },
    createdAt: '',
    flagged: false,
    id: '2',
    locale: '',
    networkId: '',
    roleId: '',
    status: MemberStatus.VERIFIED,
    teammate: false,
    updatedAt: '',
    username: 'f',
    name: 'Ali',
  },
  {
    attributes: {
      locale: '',
    },
    createdAt: '',
    flagged: false,
    id: '3',
    locale: '',
    networkId: '',
    roleId: '',
    status: MemberStatus.VERIFIED,
    teammate: false,
    updatedAt: '',
    username: 'f',
    name: 'Elham',
  },
  {
    attributes: {
      locale: '',
    },
    createdAt: '',
    flagged: false,
    id: '4',
    locale: '',
    networkId: '',
    roleId: '',
    status: MemberStatus.VERIFIED,
    teammate: false,
    updatedAt: '',
    username: 'f',
    name: 'Elham',
  },
  {
    attributes: {
      locale: '',
    },
    createdAt: '',
    flagged: false,
    id: '5',
    locale: '',
    networkId: '',
    roleId: '',
    status: MemberStatus.VERIFIED,
    teammate: false,
    updatedAt: '',
    username: 'f',
    name: 'Elham',
  },
  {
    attributes: {
      locale: '',
    },
    createdAt: '',
    flagged: false,
    id: '6',
    locale: '',
    networkId: '',
    roleId: '',
    status: MemberStatus.VERIFIED,
    teammate: false,
    updatedAt: '',
    username: 'f',
    name: 'Elham',
  },
]

export const EventAttendees = ({
  className,
  visibleCount = 2,
  avatarSize = '1.5x',
  highlighted,
  preview,
  recentRegistrations,
  endTime,
}: Props) => {
  const allItems =
    preview && (!recentRegistrations || recentRegistrations?.length === 0)
      ? STATIC_MEMBERS
      : recentRegistrations?.map(item => item.member) || []
  const isPastEvent = dayjs(endTime).isBefore(dayjs())

  if (allItems.length === 0) {
    return null
  }

  return (
    <div className="flex items-center min-w-0 gap-x-1">
      <MemberAvatars
        members={allItems}
        avatarSize={avatarSize}
        visibleCount={visibleCount}
        className={clsx(
          highlighted && 'ring-2 rounded-sm ring-offset-surface ring-focused',
          className,
        )}
        plusTooltip={
          <T
            defaultMessage="{allItemsCount} {allItemsCount, plural, one {person} other {people}} are attending this event."
            id="Event.Attendees.PlusTooltip"
            values={{
              allItemsCount: analyticsNumberFormatter(allItems.length),
            }}
          />
        }
      />
      <Text className="text-sm text-content-muted line-clamp-2">
        {!isPastEvent ? (
          <T
            defaultMessage="{count, plural, =0 {no RSVPs} one { is attending} other { are attending}}"
            id="Event.Attendees.Field.Title"
            values={{
              count: analyticsNumberFormatter(allItems.length),
            }}
          />
        ) : (
          <T
            defaultMessage="{count, plural, =0 {no RSVPs} other {attended}}"
            id="Event.Attendees.PastEvent.Field.Title"
            values={{
              count: analyticsNumberFormatter(allItems.length),
            }}
          />
        )}
      </Text>
    </div>
  )
}
